<prism-header></prism-header>

<div class="main-wrapper">
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>

